import service from '@/utils/server';

const modName = '/int/kejianTmsVehicleRecord/';

//分页查询
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//详情查询
export const detail = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/int/kejianTmsVehicleRecord/api/index.js